import { render } from "./PageProductDetail.vue?vue&type=template&id=bfcec92e"
import script from "./PageProductDetail.js?vue&type=script&lang=js"
export * from "./PageProductDetail.js?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__